import React from "react";
import useMaintenanceModeMessage from "utilities/hooks/use-maintenance-mode-message";
import ProgressBar, { ProgressBarStyles } from "atoms/progress/progress-bar";
import useAutoPageRefresh from "utilities/hooks/use-auto-page-refresh";
import { t } from "utilities/localization-utils";
import Paragraph from "atoms/typography/paragraph";
import Heading from "atoms/typography/heading";
import { HeadingPriority } from "atoms/constants/heading-priority";
import logo from "assets/images/nfpa-link-color.png";
import DateUtils from "utilities/date-utils";

const CSS_CLASS_NAME = "c-maintenance";

const MaintenancePage: React.FC<any> = (props: any) => {
    const { maintenanceModeMessage, hasAutoRefresh, timeBetweenRefreshes } =
        useMaintenanceModeMessage();
    const { timeUntilNextRefreshAsPercent, timeUntilNextRefresh } =
        useAutoPageRefresh({
            isActive: hasAutoRefresh,
            timeBetweenRefreshesInSeconds: timeBetweenRefreshes,
        });

    const currentTime = DateUtils.formatCustomDate(
        new Date()?.toISOString(),
        "MM/DD/YYYY h:mm A"
    );

    return (
        <section className={CSS_CLASS_NAME}>
            <div className={`${CSS_CLASS_NAME}__content`}>
                <div className={`${CSS_CLASS_NAME}__image-wrapper`}>
                    <img
                        className={`${CSS_CLASS_NAME}__image`}
                        src={logo}
                        alt=""
                    />
                </div>
                <span className={`${CSS_CLASS_NAME}__refresh-label`}>
                    {currentTime}
                </span>
                <Heading
                    cssClassName={`${CSS_CLASS_NAME}__heading`}
                    priority={HeadingPriority.One}>
                    {maintenanceModeMessage?.title}
                </Heading>
                <Paragraph cssClassName={`${CSS_CLASS_NAME}__body`}>
                    {maintenanceModeMessage?.content}
                </Paragraph>

                {hasAutoRefresh && (
                    <>
                        {timeUntilNextRefresh ? (
                            <Paragraph
                                cssClassName={`${CSS_CLASS_NAME}__refresh-label`}>
                                {" "}
                                {t("refreshingInNSeconds", {
                                    timeInSeconds: timeUntilNextRefresh,
                                })}
                            </Paragraph>
                        ) : (
                            <Paragraph
                                cssClassName={`${CSS_CLASS_NAME}__refresh-label`}>
                                {t("refreshing")}
                            </Paragraph>
                        )}
                        <ProgressBar
                            style={ProgressBarStyles.Thick}
                            cssClassName="-info"
                            value={timeUntilNextRefreshAsPercent}
                        />
                    </>
                )}
            </div>
        </section>
    );
};

/*
---------------------------------------------------------------------------------------------
Exports
---------------------------------------------------------------------------------------------
*/

export default MaintenancePage;
